import Autocomplete from "@mui/material/Autocomplete"
import TextField from "@mui/material/TextField"
import { Controller, Path, useFormContext } from "react-hook-form"
import { CBOmissionType, IFormValues } from "../../types"
import { useTranslation } from "react-i18next"
import { useCallback, useState } from "react"
import { useGetCountriesMetaQueryObserver } from "../../api/service/customerbaseApi"
import { useRecoilValue } from "recoil"
import { countriesState } from "../../state/customerbaseState"
import { useLocation } from "react-router-dom"

interface CBCountryControllerProps {
    idField?: string,
    formName: Path<IFormValues>,
    label: string,
    readOnly?: boolean,
    isMandatory?: boolean,
    isDisabled?: boolean,
    showSelect: boolean,
    handleBlankedValueOnChange?: () => void,
    handleAdditionalBehaviourOnBlur?: () => void
}

const CBCountryController = ({formName, label, readOnly = false, idField, showSelect, isMandatory = false, isDisabled = false, handleBlankedValueOnChange, handleAdditionalBehaviourOnBlur}: CBCountryControllerProps) => {

    const { t } = useTranslation('customerbase');
    const formContext = useFormContext<IFormValues>();
    const countryOptions = useRecoilValue(countriesState);
    /*const [countryOptions, setCountryOptions] = useState<string[]>([]);

    const countriesQuery = useGetCountriesMetaQueryObserver();
    
    const handleOnOpen = useCallback(() => {
        if(countryOptions.length == 0){
            countriesQuery.refetch().then((resp) => {
                //console.log("Resp: ", resp.data?.data?.data);
                setCountryOptions(resp.data?.data?.data || []);
            }).catch((error) => console.log(error));
        }
            
    }, []);*/

    return (
        showSelect ?
            <Controller
                control={formContext.control}
                name={formName}
                render={({field, fieldState}) => (
                    <Autocomplete
                        {...field}
                        openOnFocus
                        autoHighlight
                        autoSelect
                        fullWidth
                        disabled={isDisabled}
                        id={idField}
                        options={isMandatory ? countryOptions : ["", ...countryOptions]}
                        renderInput={(params: any) => (
                            <TextField 
                                {...params}
                                fullWidth
                                label={t(label)}
                                required={isMandatory}
                                error={Boolean(fieldState.error)}
                                helperText={fieldState.error?.message}
                            />
                        )}
                        value={field.value !== "--" ? field.value?.toString() || null : null}
                        onChange={(_event, value) => {
                            console.log("Value Country: ", value);
                            field.onChange(value);

                            if(!value && !!handleBlankedValueOnChange) handleBlankedValueOnChange();
                        }}
                        onBlur={() => {
                            field.onBlur();
                            handleAdditionalBehaviourOnBlur?.();
                        }}
                        //onOpen={handleOnOpen}
                    />
                )}
            
            />
        :
            <Controller
                control={formContext.control}
                name={formName}
                render={({field}) => (
                    <TextField 
                        {...field}
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                        //disabled={isDisabled}
                        label={t(label)}
                        required={isMandatory}
                        value={field.value || CBOmissionType.OMISSION_DASH}
                    />
                )}
            />
        
    );
}

export default CBCountryController;